module.exports = __webpack_public_path__ + "static/water-7ae922cde8a4e82b68fe3651bf74ca68.jpeg";